module.exports = __webpack_public_path__ + "img/6.352c2241.png";